import type { PlanId } from '@/shared/types/workspace';

// Owner-set plan facts (AGENTS.md, ../website apps/web/src/data/plans.ts). The checkout reads the
// server's `plans` query; these constants label plans where a second query would be wasteful.
export type PlanFacts = {
  id: PlanId;
  name: string;
  priceCents: number;
  includedPodHours: number;
  podsAtATime: number;
  extraPodHourCents: number | null;
};

export const PLAN_FACTS: Record<PlanId, PlanFacts> = {
  FREE: {
    id: 'FREE',
    name: 'Free',
    priceCents: 0,
    includedPodHours: 3,
    podsAtATime: 1,
    extraPodHourCents: null,
  },
  PRO: {
    id: 'PRO',
    name: 'Pro',
    priceCents: 9900,
    includedPodHours: 300,
    podsAtATime: 4,
    extraPodHourCents: 40,
  },
  TEAM: {
    id: 'TEAM',
    name: 'Team',
    priceCents: 39900,
    includedPodHours: 1500,
    podsAtATime: 10,
    extraPodHourCents: 30,
  },
};

export const PAID_PLAN_IDS = ['PRO', 'TEAM'] as const satisfies readonly PlanId[];

export const planName = (plan: PlanId): string => PLAN_FACTS[plan].name;
